<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-table-menu-cmr-emit',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowNumberCmrEmit',
      'isShowOrderCmrEmit',
      'isShowGroupCmrEmit',
      'isShowVehiclePlateCmrEmit',
      'isShowTrailerPlateCmrEmit',
      'isShowSenderPartyCmrEmit',
      'isShowSenderCentreCmrEmit',
      'isShowReceiverPartyCmrEmit',
      'isShowReceiverCentreCmrEmit',
      'isShowCreationDateTimeCmrEmit',
      'isShowStatusCmrEmit',
      'isShowServiceCmrEmit',
      'isShowSendDateCmrEmit',
      'isShowTransportistCmrEmit',
      'optionsFilterService'
    ])
  },

  methods: {
    ...mapActions([
      'isShowNumberCmrEmitAction',
      'isShowOrderCmrEmitAction',
      'isShowGroupCmrEmitAction',
      'isShowVehiclePlateCmrEmitAction',
      'isShowTrailerPlateCmrEmitAction',
      'isShowSenderPartyCmrEmitAction',
      'isShowSenderCentreCmrEmitAction',
      'isShowReceiverPartyCmrEmitAction',
      'isShowReceiverCentreCmrEmitAction',
      'isShowCreationDateTimeCmrEmitAction',
      'isShowStatusCmrEmitAction',
      'isShowServiceCmrEmitAction',
      'isShowSendDateCmrEmitAction',
      'isShowTransportistCmrEmitAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'num-cmr':
          isShow = !this.isShowNumberCmrEmit
          this.isShowNumberCmrEmitAction(isShow)
          break
        case 'pedido':
          isShow = !this.isShowOrderCmrEmit
          this.isShowOrderCmrEmitAction(isShow)
          break
        case 'grupo':
          isShow = !this.isShowGroupCmrEmit
          this.isShowGroupCmrEmitAction(isShow)
          break
        case 'matricula':
          isShow = !this.isShowVehiclePlateCmrEmit
          this.isShowVehiclePlateCmrEmitAction(isShow)
          break
        case 'matricula_trailer':
          isShow = !this.isShowTrailerPlateCmrEmit
          this.isShowTrailerPlateCmrEmitAction(isShow)
          break
        case 'empresa-carga':
          isShow = !this.isShowSenderPartyCmrEmit
          this.isShowSenderPartyCmrEmitAction(isShow)
          break
        case 'centro-carga':
          isShow = !this.isShowSenderCentreCmrEmit
          this.isShowSenderCentreCmrEmitAction(isShow)
          break
        case 'empresa-entrega':
          isShow = !this.isShowReceiverPartyCmrEmit
          this.isShowReceiverPartyCmrEmitAction(isShow)
          break
        case 'centro-entrega':
          isShow = !this.isShowReceiverCentreCmrEmit
          this.isShowReceiverCentreCmrEmitAction(isShow)
          break
        case 'fecha-creacion':
          isShow = !this.isShowCreationDateTimeCmrEmit
          this.isShowCreationDateTimeCmrEmitAction(isShow)
          break
        case 'estado':
          isShow = !this.isShowStatusCmrEmit
          this.isShowStatusCmrEmitAction(isShow)
          break
        case 'servicio':
          isShow = !this.isShowServiceCmrEmit
          this.isShowServiceCmrEmitAction(isShow)
          break
        case 'transportista':
          isShow = !this.isShowTransportistCmrEmit
          this.isShowTransportistCmrEmitAction(isShow)
          break
        case 'fecha-envio':
          isShow = !this.isShowSendDateCmrEmit
          this.isShowSendDateCmrEmitAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('cmr.filters.sender_party.value'), value: 'empresa-carga', show: this.isShowSenderPartyCmrEmit
        }, {
          text: this.$t('cmr.filters.sender_centre.value'), value: 'centro-carga', show: this.isShowSenderCentreCmrEmit
        }, {
          text: this.$t('cmr.filters.receiver_party.value'), value: 'empresa-entrega', show: this.isShowReceiverPartyCmrEmit
        }, {
          text: this.$t('cmr.filters.receiver_centre.value'), value: 'centro-entrega', show: this.isShowReceiverCentreCmrEmit
        }, {
          text: this.$t('cmr.filters.num_cmr.value'), value: 'num-cmr', show: this.isShowNumberCmrEmit
        }, {
          text: this.$t('cmr.filters.send_date.value'), value: 'fecha-envio', show: this.isShowSendDateCmrEmit
        }, {
          text: this.$t('cmr.filters.date_creation.value'), value: 'fecha-creacion', show: this.isShowCreationDateTimeCmrEmit
        }, {
          text: this.$t('cmr.filters.status.value'), value: 'estado', show: this.isShowStatusCmrEmit
        }, {
          text: this.$t('cmr.filters.service.value'), value: 'servicio', show: this.isShowServiceCmrEmit
        }, {
          text: this.$t('cmr.filters.transportist.value'), value: 'transportista', show: this.isShowTransportistCmrEmit
        }, {
          text: this.$t('cmr.filters.vehicle_plate.value'), value: 'matricula', show: this.isShowVehiclePlateCmrEmit
        }, {
          text: this.$t('cmr.filters.trailer_plate.value'), value: 'matricula_trailer', show: this.isShowTrailerPlateCmrEmit
        }, {
          text: this.$t('cmr.filters.order.value'), value: 'pedido', show: this.isShowOrderCmrEmit
        }, {
          text: this.$t('cmr.filters.group.value'), value: 'grupo', show: this.isShowGroupCmrEmit
        }
      ]
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'servicio') {
            this.columns.splice(index, 1)
          }
        }
        this.isShowServiceCmrEmitAction(false)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
